import { Notification } from "./entity";

export const _id = (index: number) =>
  `e99f09a7-dd88-49d5-b1c8-1daf80c2d7b${index}`;

export const _times = (index: number) =>
  // 'MM/DD/YYYY'
  [
    "11/08/2023",
    "04/09/2024",
    "09/12/2023",
    "01/01/2024",
    "04/23/2024",
    "02/29/2024",
    "05/14/2024",
    "01/13/2024",
    "06/22/2024",
    "10/05/2023",
    "07/11/2024",
    "05/22/2024",
    "03/29/2024",
    "08/29/2023",
    "11/19/2023",
    "10/24/2023",
    "12/02/2023",
    "02/13/2024",
    "09/19/2023",
    "04/17/2024",
    "12/18/2023",
    "06/27/2024",
    "10/19/2023",
    "08/09/2024",
  ][index];

export const _fullName = (index: number) =>
  [
    "Billy Stoltenberg",
    "Eloise Ebert",
    "Teresa Luettgen",
    "Salvador Mayert",
    "Dr. Guadalupe Rath",
    "Kelvin Pouros",
    "Thelma Langworth",
    "Kristen Wunsch",
    "Steve Welch",
    "Brian Jacobs",
    "Lillie Schultz",
    "Mr. Conrad Spinka",
    "Charlene Krajcik",
    "Kerry Kuhlman",
    "Betty Hammes",
    "Tony Paucek PhD",
    "Sherri Davis",
    "Angel Rolfson-Kulas",
    "Dr. Lee Doyle-Grant",
    "Cheryl Romaguera",
    "Billy Braun",
    "Adam Trantow",
    "Brandon Von",
    "Willis Ankunding",
  ][index];

export const _notifications: Notification[] = [
  {
    avatarUrl: null,
    description: "waiting for shipping",
    id: _id(1),
    isUnRead: true,
    postedAt: _times(1),
    title: "Your order is placed",
    type: "order-placed",
  },
  {
    avatarUrl: "/assets/images/avatar/avatar-2.webp",
    description: "answered to your comment on the Minimal",
    id: _id(2),
    isUnRead: true,
    postedAt: _times(2),
    title: _fullName(2),
    type: "friend-interactive",
  },
  {
    avatarUrl: null,
    description: "5 unread messages",
    id: _id(3),
    isUnRead: false,
    postedAt: _times(3),
    title: "You have new message",
    type: "chat-message",
  },
  {
    avatarUrl: null,
    description: "sent from Guido Padberg",
    id: _id(4),
    isUnRead: false,
    postedAt: _times(4),
    title: "You have new mail",
    type: "mail",
  },
  {
    avatarUrl: null,
    description: "Your order is being shipped",
    id: _id(5),
    isUnRead: false,
    postedAt: _times(5),
    title: "Delivery processing",
    type: "order-shipped",
  },
];
